import PropTypes from 'prop-types';
import { React, useEffect, useState } from 'react';

import style from '../../../../../assets/styles/testCreationStyle.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  change_test_screen,
  changeAdd_test_screen,
  Publish_Test,
  Update_Test_Details_Local,
} from '../../../../../redux/action';
import { GET_PDF_DATA, GET_TEST_LISTS } from '../../../../../action/apiPath';
import { CallWithAuth } from '../../../../../action/apiActions';
import { useToast } from '../../../common/Toast';
import { CHANGE_TEST_SCREEN } from '../../../../../redux/constant';
import { useNavigate, useLocation } from 'react-router-dom';

import Loader from '../../../../loader';

// eslint-disable-next-line react/prop-types
const AdvanceSettings = ({ isEdit, publish, setButtonStatus, setpdfResult, pdfresult, isView }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(isEdit || isView);
  const location = useLocation();
  const testAuthoringTaskId = location.state?.testAuthoringTaskId;
  const { testCreationId, sectionBody, getBasicSettingData, testDetails } = useSelector((state) => state.GetAllData);

  const [settings, setSettings] = useState({
    calculator: null,
    result_date_time: null,
    test_duration_at: 0,
    overall_test_duration: {
      hours: null,
      minutes: null,
      seconds: null,
    },
  });
  // const initialData = {
  //   section:
  //     (isEdit || isView)&&structuredClone(testDetails)?.group_details && structuredClone(testDetails)?.group_details[0]
  //       ? structuredClone(testDetails)?.group_details?.map((item) => {
  //           return { name: item?.section_name, time: { hours: 0, minutes: 0, seconds: 0 } };
  //         })
  //       : structuredClone(sectionBody)?.groups[0]?.sections[0]
  //         ? structuredClone(sectionBody)?.groups[0]?.sections?.map((item) => {
  //             return { name: item?.section_name, time: { hours: 0, minutes: 0, seconds: 0 } };
  //           })
  //         : [{ name: item?.section_name, time: { hours: 0, minutes: 0, seconds: 0 } }],
  // };
  const initialData = {
    section: [
      {
        name: '',
        time: { hours: 0, minutes: 0, seconds: 0 },
        switching_sections_allowed: false,
        enable_submit_button: false,
        enabled_calculator: false,
      },
    ],
  };
  const [data, setData] = useState(structuredClone(initialData));
  const [isInitialized, setIsInitialized] = useState(false);
  // Function to calculate overall time
  const calculateOverallTime = (sections) => {
    let totalSeconds = 0;

    sections.forEach(({ time }) => {
      const hours = time?.hours || 0;
      const minutes = time?.minutes || 0;
      const seconds = time?.seconds || 0;

      totalSeconds += hours * 3600 + minutes * 60 + seconds;
    });

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setSettings({ ...settings, overall_test_duration: { hours, minutes, seconds } });
  };

  // Handle input change
  const onhandleSectionTime = (index, field, value) => {
    if (value === '') {
      const updatedSections = data?.section?.map((section, i) =>
        i === index
          ? {
              ...section,
              time: {
                ...section.time,
                [field]: value,
              },
            }
          : section
      );

      setData((prevData) => ({
        ...prevData,
        section: updatedSections,
      }));
    } else {
      const numericValue = parseInt(value, 10) || 0;
      const updatedSections = data?.section?.map((section, i) =>
        i === index
          ? {
              ...section,
              time: {
                ...section.time,
                [field]: Math.max(0, numericValue),
              },
            }
          : section
      );

      setData((prevData) => ({
        ...prevData,
        section: updatedSections,
      }));
      calculateOverallTime(updatedSections); // Recalculate overall time
    }
  };
  const updateSectionSetting = (index, key, value) => {
    const updatedSections = data.section.map((section, i) => {
      if (i === index) {
        return { ...section, [key]: value };
      }
      return section;
    });
    setData((prevData) => ({ ...prevData, section: updatedSections }));

    if (key === 'enabled_calculator' && testDetails) {
      const updatedGroupDetails = testDetails.group_details?.map((group, idx) => {
        if (idx === index) {
          return { ...group, [key]: value };
        }
        return group;
      });

      let updatedDuration = testDetails.duration;
      if (testDetails.duration && testDetails.duration.groups_duration) {
        const updatedGroupsDuration = testDetails.duration.groups_duration.map((gd, idx) => {
          if (idx === index) {
            return { ...gd, [key]: value };
          }
          return gd;
        });
        updatedDuration = { ...testDetails.duration, groups_duration: updatedGroupsDuration };
      }

      dispatch(
        Update_Test_Details_Local({
          group_details: updatedGroupDetails,
          duration: updatedDuration,
        })
      );
    }
  };
  useEffect(() => {
    if (publish) {
      dispatch(Publish_Test(settings, isEdit ? testDetails.id : testCreationId, handleSubmit));
    }
  }, [publish]);
  const toast = useToast();
  const handleSubmit = (data) => {
    if (data.status === 200) {
      toast?.add(data.data.message, 'success');
      const screen = 0;
      dispatch({ type: CHANGE_TEST_SCREEN, screen });
      dispatch({ type: 'FLUSH_TESTPAPER_DATA' });
      navigate('/test-papers-management');
    } else {
      toast?.add(data.data.message, 'error');
    }
  };
  const handleCalculator = (e) => {
    const value = e.target.value === '' ? null : Number(e.target.value);
    setSettings((prevState) => ({
      ...prevState,
      calculator: value,
    }));
    dispatch(
      Update_Test_Details_Local({
        calculator: value,
      })
    );
  };

  const handleResultDateTime = (e) => {
    const value = e.target.value;

    setSettings((prevState) => ({
      ...prevState,
      result_date_time: value || null,
    }));
  };

  const handleOverAllDuration = (e, type) => {
    if (type === 'hours') {
      setSettings((prevSettings) => ({
        ...prevSettings,
        overall_test_duration: {
          ...prevSettings.overall_test_duration,
          hours: Number(e.target.value),
        },
      }));
    }
    if (type === 'minutes') {
      setSettings((prevSettings) => ({
        ...prevSettings,
        overall_test_duration: {
          ...prevSettings.overall_test_duration,
          minutes: Number(e.target.value),
        },
      }));
    }
    if (type === 'seconds') {
      setSettings((prevSettings) => ({
        ...prevSettings,
        overall_test_duration: {
          ...prevSettings.overall_test_duration,
          seconds: Number(e.target.value),
        },
      }));
    }
  };

  const handleLevel = (e) => {
    setSettings((prevState) => ({
      ...prevState,
      test_duration_at: Number(e.target.value),
    }));
  };

  useEffect(() => {
    if (
      settings.calculator !== null &&
      settings.result_date_time !== null &&
      settings.overall_test_duration.hours !== null &&
      settings.overall_test_duration.minutes !== null &&
      settings.overall_test_duration.seconds !== null
    ) {
      setButtonStatus(true);
    }
  }, [settings]);

  // const PdfCheck = async () => {
  //   //e.preventDefault();
  //   const url = GET_PDF_DATA + `${isEdit ? testDetails.id : testCreationId}` + `/get_test_paper_pdf/${organizationId}/`;
  //   const PdfChecking = await CallWithAuth('GET', url);
  //   if (PdfChecking.status && PdfChecking.res.status === 200) {
  //     setpdfResult(PdfChecking.res.data.test_paper_pdf_url);
  //   }
  // };
  const navigate = useNavigate();
  const handleSaveAndContinue = async (e) => {
    e.preventDefault();
    const body = {
      calculator: settings.calculator,
      result_date_time: settings.result_date_time,
      test_duration_at: 0,
      overall_test_duration: {
        total_test_duration: settings.overall_test_duration,
        ...(testDetails?.test_type === 1
          ? {
              sections_duration: data?.section?.map((item, i) => ({
                section_no: i + 1,
                hours: item.time.hours,
                minutes: item.time.minutes,
                seconds: item.time.seconds,
              })),
            }
          : {
              groups_duration: data?.section?.map((item, i) => ({
                group_id:
                  structuredClone(testDetails)?.group_details[i]?.group_id ??
                  structuredClone(testDetails)?.group_details[i]?.id,
                switching_sections_allowed: item?.switching_sections_allowed ?? false,
                enable_submit_button: item?.enable_submit_button ?? false,
                enable_reference_sheet: structuredClone(testDetails)?.group_details[i]?.enable_reference_sheet ?? false,
                enabled_calculator: settings.calculator === 4 ? (item?.enabled_calculator ?? false) : false,
                hours: item.time.hours,
                minutes: item.time.minutes,
                seconds: item.time.seconds,
              })),
            }),
      },
    };
    const url = `${GET_TEST_LISTS}${testDetails.id}/advanced_settings/`;
    const response = await CallWithAuth('PATCH', url, body);
    if (response.status && response.res.status === 200) {
      toast?.add(response.res.data.message, 'success');
      const screen = 0;
      dispatch({ type: CHANGE_TEST_SCREEN, screen });
      if (testAuthoringTaskId) {
        navigate(`/task-management/details/${testAuthoringTaskId}`);
      } else {
        navigate('/test-papers-management');
      }

      localStorage.removeItem('testAuthoringTaskId');
    } else {
      toast?.add(response.res.data.error, 'error');
    }
  };
  // useEffect(() => {
  //   if (pdfresult === null && getBasicSettingData?.test_type != 1) {
  //     const intervalId = setInterval(() => {
  //       // Call your function here
  //       PdfCheck();
  //     }, 2000); // 2000 milliseconds = 2 seconds

  //     // Clear the interval when the component unmounts or when the dependency array changes
  //     return () => clearInterval(intervalId);
  //   }
  // }, [pdfresult]);
  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
  useEffect(() => {
    if (isInitialized) return;
    if (
      (isEdit || isView) &&
      structuredClone(testDetails)?.group_details &&
      structuredClone(testDetails)?.group_details[0]
    ) {
      const newSettings = {
        calculator: testDetails?.calculator,
        result_date_time: formatDate(testDetails?.result_date_time ?? ''),
        test_duration_at: testDetails?.test_duration_at ?? null,
        overall_test_duration: {
          hours: testDetails?.duration?.hours || 0,
          minutes: testDetails?.duration?.minutes || 0,
          seconds: testDetails?.duration?.seconds || 0,
        },
      };
      if (getBasicSettingData?.test_type == 1 || testDetails?.test_type == 1) {
        newSettings.overall_test_duration = {
          hours: testDetails?.duration?.total_test_duration?.hours ?? 0,
          minutes: testDetails?.duration?.total_test_duration?.minutes ?? 0,
          seconds: testDetails?.duration?.total_test_duration?.seconds ?? 0,
        };
        if (structuredClone(testDetails?.duration?.sections_duration)) {
          const newData = structuredClone(testDetails)?.group_details?.map((item, i) => {
            return {
              name: item?.section_name,
              time: structuredClone(testDetails).duration.sections_duration[i] ?? {
                hours: 0,
                minutes: 0,
                seconds: 0,
              },
            };
          });
          setData({ section: structuredClone(newData) });
        }
      }
      if ((getBasicSettingData?.test_type && getBasicSettingData?.test_type !== 1) || testDetails?.test_type !== 1) {
        newSettings.overall_test_duration = {
          hours: testDetails?.duration?.total_test_duration?.hours ?? 0,
          minutes: testDetails?.duration?.total_test_duration?.minutes ?? 0,
          seconds: testDetails?.duration?.total_test_duration?.seconds ?? 0,
        };
        if (structuredClone(testDetails?.duration?.groups_duration)) {
          const newData = structuredClone(testDetails)?.group_details?.map((item, i) => {
            return {
              name: item?.group_name,
              time: {
                hours: structuredClone(testDetails).duration?.groups_duration[i]?.hours ?? 0,
                minutes: structuredClone(testDetails).duration?.groups_duration[i]?.minutes ?? 0,
                seconds: structuredClone(testDetails).duration?.groups_duration[i]?.seconds ?? 0,
              },
              group_id: structuredClone(testDetails).duration?.groups_duration[i]?.group_id,
              switching_sections_allowed:
                structuredClone(testDetails).duration?.groups_duration[i]?.switching_sections_allowed ?? false,
              enable_submit_button:
                structuredClone(testDetails).duration?.groups_duration[i]?.enable_submit_button ?? false,
              enabled_calculator:
                structuredClone(testDetails).duration?.groups_duration[i]?.enabled_calculator ??
                structuredClone(testDetails)?.group_details[i]?.enabled_calculator ??
                false,
            };
          });
          setData({ section: structuredClone(newData) });
        } else if (structuredClone(testDetails)?.group_details.length > 0) {
          const newData = {
            section: structuredClone(testDetails)?.group_details?.map((item) => {
              return {
                name: item?.group_name,
                time: { hours: 0, minutes: 0, seconds: 0 },
                switching_sections_allowed: false,
                enable_submit_button: false,
                enabled_calculator: item?.enabled_calculator ?? false,
              };
            }),
          };
          setData(structuredClone(newData));
        }
      }
      setSettings(structuredClone(newSettings));
      setIsInitialized(true);
      setIsLoading(false);
    } else if (structuredClone(sectionBody)?.groups && structuredClone(sectionBody)?.groups[0]) {
      const testType = getBasicSettingData?.test_type ?? testDetails?.test_type;
      if (testType === 1) {
        const newData = {
          section: structuredClone(sectionBody)?.groups[0]?.sections?.map((item) => {
            return { name: item?.section_name, time: { hours: 0, minutes: 0, seconds: 0 } };
          }),
        };
        setData(structuredClone(newData));
      } else {
        const newData = {
          section: structuredClone(sectionBody)?.groups?.map((item) => {
            return {
              name: item?.group_name,
              time: { hours: 0, minutes: 0, seconds: 0 },
              switching_sections_allowed: false,
              enable_submit_button: false,
              enabled_calculator: item?.enabled_calculator ?? false,
            };
          }),
        };
        setData(structuredClone(newData));
      }
      setIsInitialized(true);
      setIsLoading(false);
    }
    if (
      structuredClone(testDetails)?.group_details.length > 0 &&
      ((getBasicSettingData?.test_type && getBasicSettingData?.test_type !== 1) || testDetails?.test_type !== 1) &&
      !isEdit &&
      !isView
    ) {
      const newData = {
        section: structuredClone(testDetails)?.group_details?.map((item) => {
          return {
            name: item?.group_name,
            time: { hours: 0, minutes: 0, seconds: 0 },
            switching_sections_allowed: false,
            enable_submit_button: false,
            enabled_calculator: item?.enabled_calculator ?? false,
          };
        }),
      };
      setData(structuredClone(newData));
      setIsInitialized(true);
      setIsLoading(false);
    }
  }, [testDetails, isInitialized]);
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={style.masterTestCreation}>
      <form className={` ${style.testCreationArea} ${style.AdvanceBox} ${isView ? style.isViewMainContainer : ''}`}>
        <div className={style.AdvanceSettingsContainer}>
          <h5 className={`${style.testMarklabel} ${style.AdvanceSettingslabel}`}>Advance Settings</h5>
          <div className={style.bound}>
            {/* Test type */}
            <div className={style.templateDrop}>
              <div className={style.templateDrop_item}>
                <div className={style.templateGroup}>
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>Calculator</span>
                  <b className={style.red_mendantory}> *</b>
                  <select
                    name="question"
                    id="question"
                    value={settings.calculator}
                    className={`${style.template_drop_filter} select-focused`}
                    onChange={handleCalculator}
                  >
                    <option value={''}>Select Type</option>
                    <option value={0}>None</option>
                    <option value={1}>Basic</option>
                    <option value={2}>Scientific</option>
                    <option value={3}>Basic-GMAT</option>
                    <option value={4}>Scientific & Graphing Calculator - SAT</option>
                  </select>
                </div>
              </div>
            </div>

            <div className={style.templateDrop}>
              <div className={style.templateDrop_item}>
                <div className={style.templateGroup}>
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>Result Date/ Time</span>
                  <input
                    type="datetime-local"
                    name="question"
                    id="question"
                    value={settings.result_date_time}
                    className={`${style.template_drop_filter} select-focused`}
                    onChange={handleResultDateTime}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <div className={style.switching}>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                            Switching Groups Allowed
                        </span>
                        <div className={style.wrapperIcon}>
                            <div
                                className={` ${style.iconBoxs} ${settings.switching_groups_allowed ? "" : style.editOption
                                    }`}
                                onClick={() => handleSwitchGroup(false)}
                            >
                                No
                            </div>

                            <div
                                className={` ${style.iconBoxs} ${settings.switching_groups_allowed ? style.editOption : ""
                                    }`}
                                onClick={() => handleSwitchGroup(true)}
                            >
                                Yes
                            </div>
                        </div>
                    </div> */}

          {/* {testDetails?.test_type === 0 && (
            <>
              <p style={{ fontWeight: '500', marginTop: '10px' }} className={style.marketLogic}>
                Test Duration At
              </p>
              <div style={{ fontSize: '13px' }} className={style.levels}>
                <input
                  checked={settings.test_duration_at == 0}
                  type="radio"
                  name="markingLogic"
                  defaultChecked
                  value={0}
                  onClick={handleLevel}
                />
                <label htmlFor="test level">Test Level</label>
                <input
                  checked={settings.test_duration_at == 1}
                  style={{ marginLeft: '20px' }}
                  name="markingLogic"
                  type="radio"
                  value={1}
                  onClick={handleLevel}
                />
                <label htmlFor="section level">Group Level</label>
                <input
                  style={{ marginLeft: '20px' }}
                  name="markingLogic"
                  type="radio"
                  value={2}
                  checked={settings.test_duration_at == 2}
                  onClick={handleLevel}
                />
                <label htmlFor="section level">Section Level Level</label>
              </div>

              <div className={style.screenNum}>
                <p style={{ fontWeight: 500 }}>Overall Test Duration</p>

                <div className={style.timer}>
                  <input
                    value={settings.overall_test_duration.hours}
                    className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'hours')}
                  />
                  <label htmlFor="minutes">Hours</label>

                  <input
                    value={settings.overall_test_duration.minutes}
                    className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'minutes')}
                  />
                  <label htmlFor="minutes">Minutes</label>

                  <input
                    value={settings.overall_test_duration.seconds}
                    className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'seconds')}
                  />
                  <label htmlFor="second">Seconds</label>
                </div>
              </div>
            </>
          )}
          {testDetails?.test_type === 0 && (
            <div className={style.performBT} style={{ position: 'relative', top: '40px' }}>
              <button
                type="button"
                className={` ${style.btOne} ${style.common}`}
                style={{ pointerEvents: 'all' }}
                onClick={(e) => {
                  dispatch(changeAdd_test_screen(1));
                  e.preventDefault();
                }}
              >
                Back
              </button>
            </div>
          )} */}
          {
            <>
              <p style={{ fontWeight: '500', marginTop: '10px' }} className={style.marketLogic}>
                {testDetails?.test_type === 1 ? 'Test Paper Duration' : 'Overall Test Duration'}{' '}
                <b className={style.red_mendantory}> *</b>
              </p>

              <div className={style.screenNum}>
                {/* <p style={{ fontWeight: 500 }}>Overall Test Duration</p> */}

                <div className={style.timer}>
                  <input
                    value={settings.overall_test_duration.hours ?? 0}
                    disabled
                    className={` ${style.timer_input} ${style.fullbg_section} ${style.HandleTestDuration}`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'hours')}
                  />
                  <label htmlFor="minutes" className={style.timerLabel}>
                    Hours
                  </label>

                  <input
                    disabled
                    value={settings.overall_test_duration.minutes ?? 0}
                    className={` ${style.timer_input} ${style.fullbg_section} ${style.HandleTestDuration}`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'minutes')}
                  />
                  <label htmlFor="minutes" className={style.timerLabel}>
                    Minutes
                  </label>

                  <input
                    value={settings.overall_test_duration.seconds ?? 0}
                    disabled
                    className={` ${style.timer_input} ${style.fullbg_section} ${style.HandleTestDuration}`}
                    type="number"
                    name="number"
                    min="-100"
                    max="100"
                    step="1"
                    onChange={(e) => handleOverAllDuration(e, 'seconds')}
                  />
                  <label htmlFor="second" className={style.timerLabel}>
                    Seconds
                  </label>
                </div>
              </div>
              {testDetails?.test_type === 1 && (
                <p
                  style={{ fontWeight: '500', marginTop: '18px', fontSize: '16px', marginBottom: '5px' }}
                  className={style.marketLogic}
                >
                  Section Duration
                </p>
              )}
              {data?.section?.map((item, index) => (
                <div
                  key={item.name}
                  className={`${style.screenNum} ${testDetails?.test_type !== 1 ? style.loftAdvanceSetting : ''}`}
                >
                  {testDetails?.test_type === 1 && <p style={{ fontWeight: 400 }}>{item?.name}</p>}
                  {testDetails?.test_type !== 1 && (
                    <div>
                      <p className={style.groupName}>Group {index + 1} Settings</p>
                      <div className={`${style.settingRow}`}>
                        <div className={`${style.toggleGroup}`}>
                          <span className={style.btnLabel}>Enable Submit Button</span>
                          <div className={`${style.toggleButtons}`}>
                            <button
                              type="button"
                              className={!item.enable_submit_button ? `${style.active}` : `${style.notActive}`}
                              onClick={() => updateSectionSetting(index, 'enable_submit_button', false)}
                            >
                              No
                            </button>
                            <button
                              type="button"
                              className={item.enable_submit_button ? `${style.active}` : `${style.notActive}`}
                              onClick={() => updateSectionSetting(index, 'enable_submit_button', true)}
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                        <div className={`${style.toggleGroup}`}>
                          <span className={style.btnLabel}>Switching Sections Allowed</span>
                          <div className={`${style.toggleButtons}`}>
                            <button
                              type="button"
                              className={!item.switching_sections_allowed ? `${style.active}` : `${style.notActive}`}
                              onClick={() => updateSectionSetting(index, 'switching_sections_allowed', false)}
                            >
                              No
                            </button>
                            <button
                              type="button"
                              className={item.switching_sections_allowed ? `${style.active}` : `${style.notActive}`}
                              onClick={() => updateSectionSetting(index, 'switching_sections_allowed', true)}
                            >
                              Yes
                            </button>
                          </div>
                        </div>

                        {settings.calculator === 4 && (
                          <div className={`${style.toggleGroup}`}>
                            <span className={style.btnLabel}>Enable SAT Calculator</span>
                            <div className={`${style.toggleButtons}`}>
                              <button
                                type="button"
                                className={!item.enabled_calculator ? `${style.active}` : `${style.notActive}`}
                                onClick={() => updateSectionSetting(index, 'enabled_calculator', false)}
                              >
                                No
                              </button>
                              <button
                                type="button"
                                className={item.enabled_calculator ? `${style.active}` : `${style.notActive}`}
                                onClick={() => updateSectionSetting(index, 'enabled_calculator', true)}
                              >
                                Yes
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className={style.timer}>
                    <input
                      style={{ backgroundColor: 'white' }}
                      className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                      type="number"
                      name="number"
                      min="-100"
                      max="100"
                      step="1"
                      value={item?.time?.hours ?? ''}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => onhandleSectionTime(index, 'hours', e.target.value)}
                    />
                    <label htmlFor="minutes" className={style.timerLabel}>
                      Hours
                    </label>

                    <input
                      style={{ backgroundColor: 'white' }}
                      className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                      type="number"
                      name="number"
                      min="-100"
                      max="100"
                      step="1"
                      value={item?.time?.minutes ?? ''}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => onhandleSectionTime(index, 'minutes', e.target.value)}
                    />
                    <label htmlFor="minutes" className={style.timerLabel}>
                      Minutes
                    </label>

                    <input
                      style={{ backgroundColor: 'white' }}
                      className={` ${style.timer_input} ${style.fullbg_section} select-focused`}
                      type="number"
                      name="number"
                      min="-100"
                      max="100"
                      step="1"
                      value={item?.time?.seconds ?? ''}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => onhandleSectionTime(index, 'seconds', e.target.value)}
                    />
                    <label htmlFor="second" className={style.timerLabel}>
                      Seconds
                    </label>
                  </div>
                </div>
              ))}
              <div style={{ marginTop: '40px', marginBottom: '40px' }} className={style.performBT}>
                <button
                  type="button"
                  className={` ${style.btOne} ${style.common}`}
                  style={{ pointerEvents: 'all' }}
                  onClick={(e) => {
                    dispatch(changeAdd_test_screen(1));
                    e.preventDefault();
                  }}
                >
                  Back
                </button>
                {!isView && (
                  <button className={` ${style.btTwo} ${style.common}`} onClick={(e) => handleSaveAndContinue(e)}>
                    {isEdit ? 'Update Test' : 'Create Test'}
                  </button>
                )}
              </div>
            </>
          }
          {/*? {settings.test_duration_at == 0 ? <TestLevel setlevelSetting={setlevelSetting} /> : ""}
                    {settings.test_duration_at == 1 ? <GroupLevel setlevelSetting={setlevelSetting} /> : ""}
                    {settings.test_duration_at == 2 ? <SectionLevel setlevelSetting={setlevelSetting} /> : ""} */}
        </div>
      </form>
    </div>
  );
};

AdvanceSettings.propTypes = {
  isEdit: PropTypes.any,
  isView: PropTypes.any,
  pdfresult: PropTypes.any,
  publish: PropTypes.any,
  setButtonStatus: PropTypes.func,
  setpdfResult: PropTypes.func,
};

export default AdvanceSettings;
